module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Sopelana-d2707df2127129e2f0b8e767d97272d1.jpg";